import { useReducer, useCallback } from 'react'
import { useSubscription } from 'streamr-client-react'
import useIsMounted from '~hooks/useIsMounted'

const reducer = (state, data) => {
    const { broker, trackers } = data || {}

    return {
        messagesPerSecond: broker ? Math.round(broker.messagesToNetworkPerSec) : undefined,
        numberOfNodes: trackers ? trackers.totalNumberOfNodes : undefined,
        ready: !!data,
    }
}

export default function useNetworkStats() {
    const [stats, updateStats] = useReducer(reducer, reducer())

    const isMounted = useIsMounted()

    const onMessage = useCallback(
        (d) => {
            if (isMounted()) {
                updateStats(d)
            }
        },
        [isMounted],
    )

    useSubscription({
        stream: 'streamr.eth/metrics/network/sec',
        resend: {
            last: 1,
        },
    }, {
        onMessage,
    })

    return stats
}
